"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformDomainApi = exports.SdPlatformDomainQueryEmbeddableFields = exports.SdPlatformDomainGetEmbeddableFields = void 0;
const SdPlatformRequestId_1 = require("../api/SdPlatformRequestId");
const ResourcesApi_1 = require("./commons/ResourcesApi");
var SdPlatformDomainGetEmbeddableFields;
(function (SdPlatformDomainGetEmbeddableFields) {
    SdPlatformDomainGetEmbeddableFields["Models"] = "models";
})(SdPlatformDomainGetEmbeddableFields = exports.SdPlatformDomainGetEmbeddableFields || (exports.SdPlatformDomainGetEmbeddableFields = {}));
var SdPlatformDomainQueryEmbeddableFields;
(function (SdPlatformDomainQueryEmbeddableFields) {
    SdPlatformDomainQueryEmbeddableFields["ModelsCount"] = "models_count";
})(SdPlatformDomainQueryEmbeddableFields = exports.SdPlatformDomainQueryEmbeddableFields || (exports.SdPlatformDomainQueryEmbeddableFields = {}));
/**
 * Operations for domains which can be attached or users, organizations, models.
 */
class SdPlatformDomainApi extends ResourcesApi_1.ResourcesApi {
    get __resourcePath() {
        return "domains";
    }
    /**
     * Get a domain by id.
     * @param id
     * @param embed - array of {@link SdPlatformDomainGetEmbeddableFields}
     * @returns - {@link SdPlatformGetResponse} with {@link SdPlatformResponseDomain} as result.
     */
    get(id, embed = []) {
        return super.__get(SdPlatformRequestId_1.RequestId.DomainGet, id, embed);
    }
    /**
     * Query domains.
     * @param query
     * @returns
     */
    query(query = {}) {
        return super.__query(SdPlatformRequestId_1.RequestId.DomainQuery, query);
    }
    /**
     * Create a new domain.
     * @param body - {@link SdPlatformRequestDomainCreate} as request body.
     * @returns - new domain.
     */
    create(body) {
        return super.__post(SdPlatformRequestId_1.RequestId.DomainCreate, body);
    }
    /**
     * Patch a domain.
     * @param id - the id of a domain
     * @param body - {@link SdPlatformRequestDomainPatch} as properties to patch.
     */
    patch(id, body) {
        return super.__patch(SdPlatformRequestId_1.RequestId.DomainPatch, id, body);
    }
    /**
     * Delete a domain.
     * @param id - the id of a domain
     */
    delete(id) {
        return super.__delete(SdPlatformRequestId_1.RequestId.DomainDelete, id);
    }
}
exports.SdPlatformDomainApi = SdPlatformDomainApi;
//# sourceMappingURL=SdPlatformDomainApi.js.map